<template>
    <div class="one-to-one__section">

        <h2 class="one-to-one__section-title">{{ $t("attraction") }}</h2>

        <div class="understanding-graph">
            <img
                class="understanding-graph__partner"
                width="152"
                height="273"
                :src="artworkFriendUrl"
                alt="" />

            <ul>
                <li
                    v-for="(item, index) in descData"
                    :key="`attraction-desc-${index}`">
                    {{ capitalize(item) }}
                </li>
            </ul>

            <img
                class="understanding-graph__user"
                width="152"
                height="273"
                :src="artworkUserUrl"
                alt="" />
        </div>

    </div>
</template>

<script>

export default {
    name: "AttractionSection",
    props: {
        attractionData: {
            type: Object,
            required: true
        },
    },
    data () {
        return {};
    },
    computed: {
        descData() {
            const splitDesc = this.attractionData.desc.split(",");

            let cleanedSplitDesc = [];

            for (var i = splitDesc.length - 1; i >= 0; i--) {
                const itemTrimmed = splitDesc[i].trim();

                if (typeof(itemTrimmed) !== undefined && itemTrimmed !== "" && itemTrimmed.length) {
                    cleanedSplitDesc.push(itemTrimmed);
                }
            }

            return cleanedSplitDesc;
        },
        artworkFriendUrl() {
            return require(`@/assets/images/artworks/gender/${(this.attractionData.match_gender === "F") ? "female" : "male"}-dotted.svg`);
        },
        artworkUserUrl() {
            return require(`@/assets/images/artworks/gender/${(this.attractionData.gender === "F") ? "female" : "male"}-dotted.svg`);
        }
    },
    mounted: function() {
    },
};

</script>